module.exports = __webpack_public_path__ + "source/img/volume-mute.4571b1f7.svg";